import styled from "styled-components";

export const ClosingBlockSection = styled("section")`
  position: relative;
  padding-top: 14rem;
  padding-bottom: 5rem;


  @media screen and (max-width: 1024px) {
    padding: 8rem 0 0rem;
    padding-bottom: 5rem;
  }
`;


export const ContentWrapper = styled("div")`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: flex-start;
  max-width: 1140px;
  width: 100%;

  @media only screen and (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    text-align: center;

    & > .left-column {
      padding: 0 10px;
      width: 100%;
      position: relative;
      min-height: 500px; 
    }
  }
`;

export const CoreTitle = styled("h6")`
  font-size: 55px;
  line-height: 1rem;
  padding: 0.8rem 0;
  color: #2A3273;
  font-family: "Gilroy Bold", sans-serif;

  @media only screen and (max-width: 997px) {
    font-size: 36px;
  }

  @media only screen and (max-width: 467px) {
    font-size: 32px;
  }
`;

export const CoreSlogan = styled("h6")`
  font-size: 50px;
  line-height: 1rem;
  padding: 0.8rem 0;
  color: #2159A6;
  font-family: "Gilroy Bold", sans-serif;

  @media only screen and (max-width: 997px) {
    font-size: 24px;
  }

  @media only screen and (max-width: 467px) {
    font-size: 20px;
  }
`;

export const FourPetalFlower = styled.div`
  position: absolute;
  width: 220px;
  height: 220px;
  left: 0;
  bottom: 180px;
  margin: 0 auto;

  &::before,
  &::after,
  .petal-horizontal,
  .petal-vertical {
    content: '';
    position: absolute;
    width: 110px;
    height: 110px;
    background-color: #2159A6;
    border-radius: 50%;
  }

  &::before {
    top: 0;
    left: 50%;
    transform: translateX(-50%);
  }

  &::after {
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
  }

  .petal-horizontal {
    top: 50%;
    left: 0;
    transform: translateY(-50%);
  }

  .petal-vertical {
    top: 50%;
    right: 0;
    transform: translateY(-50%);
  }

  @media only screen and (max-width: 845px) {
    width: 100px;
    height: 100px;
    bottom: 200px;

    &::before,
    &::after,
    .petal-horizontal,
    .petal-vertical {
      width: 50px;
      height: 50px;
    }
  }
`;

export const FourPetalFlower2 = styled.div`
  position: absolute;
  width: 240px;
  height: 220px;
  right: 0;
  top: 350px;
  margin: 0 auto;

  &::before,
  &::after,
  .petal-horizontal,
  .petal-vertical {
    content: '';
    position: absolute;
    width: 110px;
    height: 110px;
    background-color: #2A3273;
    border-radius: 50%;
  }

  &::before {
    top: 0;
    left: 50%;
    transform: translateX(-50%);
  }

  &::after {
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
  }

  .petal-horizontal {
    top: 50%;
    left: 0;
    transform: translateY(-50%);
  }

  .petal-vertical {
    top: 50%;
    right: 0;
    transform: translateY(-50%);
  }

  @media screen and (max-width: 1024px) {
    width: 200px;
    height: 170px;
    top: 270px;

    &::before,
    &::after,
    .petal-horizontal,
    .petal-vertical {
      width: 90px;
      height: 100px;
  }

  @media only screen and (max-width: 845px) {
    width: 100px;
    height: 100px;
    top: 270px;

    &::before,
    &::after,
    .petal-horizontal,
    .petal-vertical {
      width: 50px;
      height: 50px;
    }
  }
`;